import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { GruppoRami } from 'src/app/models/gruppo-rami';
import { GruppoRamiService } from 'src/app/services/gruppo-rami.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditGruppoRamiComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'gruppi-rami',
  templateUrl: './gruppi-rami.component.html',
  styleUrls: ['./gruppi-rami.component.scss']
})
export class GruppiRamiComponent implements OnInit {


  headingText: string = 'Gruppi rami';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Descrizione',
        internalName: 'descrizione',
      }
    ),

  ];
  constructor(public gruppoRamiService: GruppoRamiService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<GruppiRamiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un gruppo di rami';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (gruppoRami: GruppoRami) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il gruppo di rami ${gruppoRami.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.gruppoRamiService.delete(gruppoRami);
          this.toast.success('Gruppo di rami eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione gruppo di rami fallita.", "Errore!");
    }
  }



  editFunction = async (gruppoRami: GruppoRami) => {
    try {
      let dialogRef = this.dialog.open(EditGruppoRamiComponent, { data: gruppoRami });
      dialogRef.afterClosed().subscribe(async (data: GruppoRami) => {
        if (data) {

          Object.assign(gruppoRami, data);

          await this.gruppoRamiService.edit(gruppoRami);

          this.toast.success('Gruppo di rami modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica gruppo di rami fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditGruppoRamiComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(gruppoRami?: GruppoRami) {
    if (gruppoRami) {
      try {
        await this.gruppoRamiService.create(gruppoRami)
        this.toast.success('Gruppo di rami creato!')
      }
      catch (e) {
        this.toast.error('Creazione gruppo di rami fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
